import { render } from "./_FastPayment.vue?vue&type=template&id=0ad9d2f2"
import script from "./_FastPayment.vue?vue&type=script&lang=js"
export * from "./_FastPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__